import { useState } from 'react';

export enum StateName {
    isFrozen = 'isFrozen',
    isEditInProgress = 'isEditInProgress',
}

export const useEditState = () => {
    const [isFormFrozen, setIsFormFrozen] = useState(true);
    const [isEditInProgress, setIsEditInProgress] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const setValueState = (stateName: StateName, newState: boolean) => {
        if (stateName === StateName.isFrozen) {
            setIsFormFrozen(newState);
        } else if (stateName === StateName.isEditInProgress) {
            setIsEditInProgress(newState);
        }

        setIsDirty(true);
    };

    return {
        isFormFrozen,
        isDirty,
        isEditInProgress,
        setValueState,
    };
};
